import type { Pagination, Rsp } from "@repo/types";
import { getHttpClient } from "./http";
import type {
  StorageFile,
  StorageFileListQuery,
  StorageQuotaBuyRequest,
  StorageQuotaBuyResponse,
  StorageQuotaInfo,
  StorageQuotaPackage,
} from "./storage.type";

export const StorageAPI = {
  getQuotaInfo() {
    return getHttpClient().get<Rsp<StorageQuotaInfo>>({
      url: "/storage/quota/info",
    });
  },
  /** 容量包价格表（20 档 × 月付/年付），价格以服务端为准 */
  listQuotaPackages() {
    return getHttpClient().get<Rsp<StorageQuotaPackage[]>>({
      url: "/storage/quota/packages",
    });
  },
  /** 购买容量包（创建待支付订单，3 分钟支付超时），支付走统一收银台 OrdersAPI.payOrder */
  buyQuota(data: StorageQuotaBuyRequest) {
    return getHttpClient().post<Rsp<StorageQuotaBuyResponse>>({
      url: "/storage/quota/buy",
      data,
    });
  },
  listFiles(query: StorageFileListQuery = {}) {
    const params = new URLSearchParams();
    params.set("page", String(query.page ?? 1));
    params.set("page_size", String(query.pageSize ?? 20));
    if (query.fileName) {
      params.set("file_name", query.fileName);
    }
    if (query.business) {
      params.set("business", query.business);
    }
    if (query.sortBy) {
      params.set("sort_by", query.sortBy);
    }
    if (query.sortOrder) {
      params.set("sort_order", query.sortOrder);
    }
    return getHttpClient().get<Rsp<Pagination<StorageFile[]>>>({
      url: `/storage/file/list?${params}`,
    });
  },
};
